/**
 * Kriptonio Private API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: private
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type OrganizationRole = 'User' | 'Owner';

export const OrganizationRole = {
    User: 'User' as OrganizationRole,
    Owner: 'Owner' as OrganizationRole
};

